import {
	IntegrationResponseDTO,
	IntegrationCategoryResponseDTO,
} from '@core/api/dtos/response/integration/integration'
import {
	Integration,
	IntegrationCategory,
	IntegrationType,
} from '@core/api/entities/integration'

export class IntegrationMapper {
	static toEntity(dto: IntegrationResponseDTO): Integration {
		return {
			type: dto.type as IntegrationType,
			name: dto.name,
			icon: dto.icon,
			modal_title: dto.modal_title,
			modal_content: dto.modal_content,
			modal_submit: dto.modal_submit,
			modal_cancel: dto.modal_cancel,
			typeform_url: dto.typeform_url,
		}
	}

	static toEntities(dtos: IntegrationResponseDTO[]): Integration[] {
		return dtos.map((dto) => this.toEntity(dto))
	}

	static toCategoryEntity(
		dto: IntegrationCategoryResponseDTO
	): IntegrationCategory {
		return {
			id: dto.id,
			name: dto.name,
			description: dto.description,
		}
	}

	static toCategoryEntities(
		dtos: IntegrationCategoryResponseDTO[]
	): IntegrationCategory[] {
		return dtos.map((dto) => this.toCategoryEntity(dto))
	}
}
